<div class="equipment-type-combobox">
  <input
    type="text"
    autocomplete="off"
    [id]="id"
    [name]="name"
    [class]="inputClass"
    [placeholder]="placeholder"
    [formControl]="displayControl"
    [matAutocomplete]="equipmentTypeAutocomplete"
    (focus)="openPanel()"
    (click)="openPanel()"
    (keydown.tab)="handleTabSelection()"
    (blur)="handleBlur()">

  <button
    type="button"
    class="equipment-type-combobox__toggle"
    tabindex="-1"
    aria-label="Open equipment type dropdown"
    (mousedown)="$event.preventDefault()"
    (click)="openPanel()">
    <span class="equipment-type-combobox__caret"></span>
  </button>
</div>

<mat-autocomplete
  #equipmentTypeAutocomplete="matAutocomplete"
  class="equipment-type-combobox-panel"
  [displayWith]="displayEquipmentType"
  (optionSelected)="selectEquipment($event)">
  <mat-option *ngFor="let equipmentType of filteredEquipmentTypes" [value]="equipmentType">
    <span [innerHTML]="highlightMatch(equipmentType.value)"></span>
  </mat-option>

  <mat-option *ngIf="loading && !filteredEquipmentTypes.length" disabled>
    Loading equipment types...
  </mat-option>

  <mat-option *ngIf="!loading && !filteredEquipmentTypes.length" disabled>
    No matching equipment types
  </mat-option>
</mat-autocomplete>
